import { render, staticRenderFns } from "./SectionWithDivider.vue?vue&type=template&id=724f7fb1&scoped=true"
import script from "./SectionWithDivider.vue?vue&type=script&lang=js"
export * from "./SectionWithDivider.vue?vue&type=script&lang=js"
import style0 from "./SectionWithDivider.vue?vue&type=style&index=0&id=724f7fb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f7fb1",
  null
  
)

export default component.exports